import React from "react";

function MerchantLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12.487C1.99998 12.3441 2.03059 12.2029 2.08976 12.0728C2.14892 11.9428 2.23528 11.8269 2.343 11.733L6 8.544V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM9 19H12V12.942L8 9.454L4 12.942V19H7V15H9V19ZM14 19H20V5H8V7.127C8.234 7.127 8.469 7.209 8.657 7.374L13.657 11.733C13.7647 11.8269 13.8511 11.9428 13.9102 12.0728C13.9694 12.2029 14 12.3441 14 12.487V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
        fill="#6D758E"
      />
    </svg>
  );
}

export default MerchantLogo;
